import { useState } from "react";
import { Helmet } from "react-helmet-async";
import { Play } from "lucide-react";
import { SectionHeading } from "../common/ui";
import { getBaseUrl } from "../SEO/SEOHead";

// Product intro: a self-hosted narrated video with captions (public/videos).
// Shows a designed thumbnail until clicked, then swaps in the player and starts it.
// nginx caches images for a year, so give replacement files a new name rather than overwriting.
const VIDEO = "/videos/froth-testops-intro.mp4";
const POSTER = "/videos/froth-testops-intro-poster.jpg";
const CAPTIONS = "/videos/froth-testops-intro.vtt";

export default function QATestingSection() {
  const [playing, setPlaying] = useState(false);
  const base = getBaseUrl();
  const videoSchema = {
    "@context": "https://schema.org",
    "@type": "VideoObject",
    name: "Froth TestOps product intro",
    description:
      "A narrated screen recording of one project in Froth TestOps: the project dashboard, test management with FrothAI test generation, test plans and cycles, defects, tasks, the test labs and Ask FrothAI answering a coverage question.",
    thumbnailUrl: `${base}${POSTER}`,
    contentUrl: `${base}${VIDEO}`,
    uploadDate: "2026-11-04",
    duration: "PT1M43S",
  };

  return (
    <section className="ft-section ft-section--alt home-ai">
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(videoSchema)}</script>
      </Helmet>
      <div className="ft-container">
        <SectionHeading
          eyebrow="Watch"
          title={
            <>
              See Froth TestOps <span>in action</span>
            </>
          }
          subtitle="A short narrated tour, with captions, of one real project: its dashboard, test management, test plans and cycles, defects, tasks and FrothAI."
          more={{ to: "/contact", label: "Book a live walkthrough" }}
        />
        <div className="home-video">
          {playing ? (
            <video className="home-video__player" controls autoPlay preload="none" poster={POSTER} playsInline>
              <source src={VIDEO} type="video/mp4" />
              <track kind="captions" src={CAPTIONS} srcLang="en" label="English" default />
              Your browser does not support the video tag. <a href={VIDEO}>Download the intro</a>.
            </video>
          ) : (
            <button type="button" className="home-video__poster" onClick={() => setPlaying(true)} aria-label="Play the Froth TestOps product intro (1 minute 43 seconds)">
              <img src={POSTER} alt="" width="1280" height="720" loading="lazy" decoding="async" />
              <span className="home-video__play">
                <span className="home-video__play-icon">
                  <Play size={18} fill="currentColor" aria-hidden="true" />
                </span>
                <span className="home-video__label">Watch the intro</span>
                <span className="home-video__time">1:43</span>
              </span>
            </button>
          )}
        </div>
      </div>
    </section>
  );
}
